export function statusTextForResult(result: sage.model.IResult): string {
    switch (result.state) {
        case "ERROR":
            return "Error occurred. Please reach out to Rend A Hand support.";
        case "NO_FRAMES":
            return "No frames found. Please reach out to Rend A Hand support.";
        case "FINISHED":
            return "Result finished successufully!";
        case "ASSEMBLING":
            return "Assembling your result...";
    }
}

export function colorclassForResult(result: sage.model.IResult): string {
    switch (result.state) {
        case "ASSEMBLING":
            return "primary";
        case "FINISHED":
            return "success";
        case "ERROR":
        case "NO_FRAMES":
            return "danger";
    }
}
